import React, {useContext, useState} from "react";
import FormControl from "@mui/material/FormControl";
import {CircularProgress, FormControlLabel, FormLabel, Radio, RadioGroup, Stack} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import ZiggyContext from "../../store/ziggy-context";
import useWarehouses from "../../utils/useWarehouses";

export default function Warehouses(props) {

    const ziggyCtx = useContext(ZiggyContext);
    const [warehouse, setWarehouse] = useState(ziggyCtx.warehouse);
    const warehouses = useWarehouses();
    const loadingWarehouses = warehouses.length === 0;

    function handleChange(event) {
        setWarehouse(event.target.value);
        ziggyCtx.updateWarehouse(event.target.value)
        props.handleChange();
    }

    return <MenuItem>
        <FormControl component="fieldset">
            <Stack direction="row" spacing={1} alignItems="center">
                <FormLabel component="legend">Warehouse</FormLabel>
                {loadingWarehouses && <CircularProgress size={14}/>}
            </Stack>
            <RadioGroup
                aria-label="gender"
                name="controlled-radio-buttons-group"
                value={loadingWarehouses ? 'All' : warehouse}
                onChange={handleChange}
            >
                 <FormControlLabel key={0} value={'All'} control={<Radio/>}
                                      label={'All'}/>
                {warehouses.map(({code, title}, idx) => (
                    <FormControlLabel key={idx} value={code} control={<Radio/>}
                                      label={title}/>
                ))}

            </RadioGroup>
        </FormControl>
    </MenuItem>
}